<template>
  <section class="container mx-auto">
    <div id="card-performance" v-if="typeCourse === 'true'">
      <CourseLearningMapStudent
        v-if="showLearningMapStudent"
        @onCloseMap="closeMapStudent"
      />
      <div class="w-full mt-16 p-2 md:p-0 space-y-4">
        <h4 class="text-[24px] font-[500]">
          {{
            $t("labels.generic", {
              pt: "Meu desempenho",
              en: "My performance",
            })
          }}
        </h4>
      </div>
      <div
        class="w-full mt-8 pb-8 overflow-x-auto sm:px-0 px-2 space-y-8"
        v-motion
        :initial="initialMotion"
        :enter="enterMotion.getEnterMotion(100)"
      >
        <div
          class="w-full sm:w-[40%] bg-white h-[140px] shadow-md rounded-md flex flex-row hover:bg-h-primary-50 hover:shadow-lg hover:cursor-pointer sm:min-w-[360px]"
        >
          <div class="flex-1" @click="showLearningMapStudent = true">
            <div class="flex flex-row items-center gap-3 p-4 h-[80px]">
              <MagicSvg
                id="custom-quiz-svg"
                path="course-student/icon-card.svg"
                color="text-h-primary-50 stroke-h-primary-900"
              />
              <h5>
                {{
                  $t("labels.generic", {
                    pt: "Mapa de conteúdos",
                    en: "Content map",
                  })
                }}
              </h5>
            </div>
            <div class="border-t-2 border-[#E6EFF9] h-[1px] w-full"></div>
            <div class="flex items-center h-[60px] px-4">
              <p>
                {{
                  $t("labels.generic", {
                    pt: "Visualize e acesse tudo que você ja completou no curso",
                    en: "Visualize and access",
                  })
                }}
              </p>
            </div>
          </div>
          <button
            @click="showLearningMapStudent = true"
            class="bg-h-primary-500 w-[58px] sm:w-[80px] rounded-r-md text-white flex justify-center items-center"
          >
            <v-icon name="md-arrowforward" class="text-white" />
          </button>
        </div>
      </div>
    </div>
    <Loader :loader="loader" />
    <div
      class="w-full mt-8 pb-20 overflow-x-auto sm:px-0 px-2 space-y-8"
      v-if="!loader && quizResult.completedLearningObjectives > 0"
    >
      <h4 class="text-[24px] font-[500]">
        {{
          $t("labels.generic", {
            pt: "Histórico no quiz",
            en: "Quiz history",
          })
        }}
      </h4>
      <div
        class="flex flex-col md:flex-row w-full space-y-2 md:space-y-0 md:space-x-4"
        v-motion
        :initial="initialMotion"
        :enter="enterMotion.getEnterMotion(0)"
      >
        <div
          class="flex flex-row justify-between bg-white md:w-[426px] w-full h-[97px] rounded-md shadow-md p-4 border-b-4 border-h-primary-500"
        >
          <div class="h-full flex flex-col justify-between">
            <h6 class="text-[16px]">
              {{
                $t("labels.generic", {
                  pt: "Média de acertos nos quizzes",
                  en: "Average scores on quizzes",
                })
              }}
            </h6>
            <h5 class="text-[20px] font-[500]">
              {{
                quizResult.average === 0 || quizResult.average === undefined
                  ? "-"
                  : Math.ceil(quizResult.average) + "%"
              }}
            </h5>
          </div>

          <MagicSvg
            id="custom-quiz-svg"
            path="course-student/quiz-average.svg"
            color="text-h-primary-50 stroke-h-primary-900"
          />
        </div>
        <div
          class="flex flex-row justify-between bg-white w-full md:w-[426px] sm:h-[97px] rounded-md shadow-md p-4 border-b-4 border-h-primary-500"
        >
          <div class="h-full flex flex-col justify-between">
            <h4 class="text-[16px]">
              {{
                $t("labels.generic", {
                  pt: "Objetivos de aprendizagens finalizados",
                  en: "Completed learning objectives",
                })
              }}
            </h4>
            <h5 class="text-[20px] font-[500]">
              {{
                quizResult.completedLearningObjectives === 0
                  ? "-"
                  : quizResult.completedLearningObjectives
              }}
            </h5>
          </div>

          <MagicSvg
            id="custom-quiz-svg"
            path="course-student/objective-complete.svg"
            color="text-h-primary-50 stroke-h-primary-900"
          />
        </div>
      </div>
      <div
        v-motion
        :initial="initialMotion"
        :enter="enterMotion.getEnterMotion(100)"
        class="mt-4 grid-cols-4 border-l-4 bg-white p-4 shadow-md border-h-primary-800 rounded-md w-full max-w-full hidden sm:grid"
      >
        <p class="text-[16px] font-[800]">
          {{ $t("labels.generic", { pt: "Capítulo", en: "Chapter" }) }}
        </p>
        <p class="text-[16px] font-[800]">
          {{ $t("labels.generic", { pt: "Objetivo de aprendizagem", en: "Learning Object" }) }}
        </p>
        <p class="text-[16px] font-[800]">
          {{ $t("labels.generic", { pt: "Percentual de acertos", en: "Percentage of correct answers" }) }}
        </p>
        <p class="text-[16px] font-[800]">Status</p>
      </div>
      <div
        v-for="(item, i) in quizResult?.quizRecords"
        :key="`desktop-${i}`"
        v-motion
        :initial="initialMotion"
        :enter="enterMotion.getEnterMotion((i + 1) * 100)"
        class="mt-4 grid-cols-4 border-l-4 bg-white p-4 shadow-md border-h-primary-800 rounded-md w-full max-w-full hidden sm:grid"
      >
        <p class="text-[16px] font-[600]">{{ item.chapterName }}</p>
        <p class="text-[16px] font-[600]">{{ item.objectiveName }}</p>
        <p class="text-[16px] font-[600]">{{ Math.ceil(item.percentage) + "%" }}</p>
        <p
          :class="`flex justify-center rounded-lg p-1 items-center text-[12px] font-[600] w-[68px] ${
            item.status === 'PASSED'
              ? 'bg-h-success-100 text-h-success-500'
              : 'bg-h-warning-100 text-h-warning-800'
          }`"
        >
          {{ item.status === "PASSED" ? "Aprovado" : "Reprovado" }}
        </p>
      </div>
      <div
        v-for="(item, i) in quizResult?.quizRecords"
        :key="`mobile-${i}`"
        v-motion
        :initial="initialMotion"
        :enter="enterMotion.getEnterMotion((i + 1) * 100)"
        class="sm:hidden mt-4 border-l-4 bg-white p-4 shadow-md border-h-primary-800 rounded-md space-y-2"
      >
        <p class="text-[14px] font-[800]">
          {{ $t("labels.generic", { pt: "Capítulo", en: "Chapter" }) }}:
          <span class="font-[600]">{{ item.chapterName }}</span>
        </p>
        <p class="text-[14px] font-[800]">
          {{ $t("labels.generic", { pt: "Objetivo de aprendizagem", en: "Learning Object" }) }}:
          <span class="font-[600]">{{ item.objectiveName }}</span>
        </p>
        <p class="text-[14px] font-[800]">
          {{ $t("labels.generic", { pt: "Percentual de acertos", en: "Percentage of correct answers" }) }}:
          <span class="font-[600]">{{ Math.ceil(item.percentage) + "%" }}</span>
        </p>
        <p class="text-[14px] font-[800]">
          Status:
          <span
            :class="`ml-2 px-2 py-[2px] rounded-sm text-[12px] font-[600] ${
              item.status === 'PASSED'
                ? 'bg-h-success-200 text-h-success-700'
                : 'bg-h-warning-100 text-h-warning-500'
            }`"
          >
            {{ item.status === "PASSED" ? "Aprovado" : "Reprovado" }}
          </span>
        </p>
      </div>
      </div>

    <div
      v-motion
      :initial="initialMotion"
      :enter="enterMotion.getEnterMotion(0)"
      v-if="!loader && quizResult.completedLearningObjectives === 0"
      class="w-full flex flex-col justify-center items-center mt-16 md:min-h-[50vh]"
    >
      <img
        src="@/assets/images/course-student/empty-quiz.svg"
        alt="empty-quiz"
      />
      <span class="font-[700] text-[14px] text-gray-600 mt-8">
        {{
          $t("labels.generic", { pt: "Nenhum quiz feito", en: "No quiz taken" })
        }}
      </span>
      <span class="font-[600] text-[14px] text-gray-600 text-center">
        {{
          $t("labels.generic", {
            pt: "Você ainda não fez nenhum quiz, os seus resultados ficarão aqui.",
            en: "You haven't taken any quiz yet, your results will be here.",
          })
        }}
      </span>
    </div>
  </section>
</template>

<script lang="ts">
import { MotionEnter, MotionInitial } from "@/models/motion.model";
import { QuizResultsHistory } from "@/models/quiz.model";
import { getUserFromStorage } from "@/utils/user-store.util";
import { debounceTime } from "rxjs";
import { defineComponent } from "vue";
import { CourseStudentService } from "../course-student.service";

export default defineComponent({
  name: "courseQuizResult",
  computed: {
    service(): CourseStudentService {
      return new CourseStudentService();
    },
    idCourse(): any {
      return this.$route.params.id;
    },
    user(): any {
      return getUserFromStorage();
    },
    typeCourse(): string {
      return String(localStorage.getItem("course-type"));
    },
  },
  data() {
    return {
      quizResult: {} as QuizResultsHistory,
      showLearningMapStudent: false as boolean,
      loader: true as boolean,
      initialMotion: new MotionInitial(),
      enterMotion: new MotionEnter(),
    };
  },
  mounted() {
    this.getUserResultsHistory();
  },
  methods: {
    getUserResultsHistory(): void {
      this.service.myPerformance.pipe(debounceTime(500)).subscribe({
        next: (response) => {
          this.quizResult = response;
          this.loader = false;
        },
      });
      this.service.getUserResultsHistory(this.user?.id, this.idCourse);
    },
    closeMapStudent(): void {
      this.showLearningMapStudent = false;
    },
  },
});
</script>

<style lang="scss">
#custom-quiz-svg {
  svg,
  path {
    width: 100%;
    height: auto;
    @apply fill-current #{!important};
  }
}
</style>
